import React from 'react'
import { Sale } from 'src/core/models'
import { CustomTag } from 'src/components'
import { useTranslation } from 'next-i18next'
import { getSaleStatus } from 'src/core/helpers'

const SaleStatusColumn: React.FC<{ sale: Sale }> = ({ sale }) => {
  const { t } = useTranslation()
  const status = getSaleStatus(sale)

  const saleStatus = {
    AWAITING_DOCS: { label: t('Transactions.AwaitingDocs'), type: 'default' },
    AWAITING_VALIDATION: { label: t('Transactions.AwaitingValidation'), type: 'default' },
    COMPLETED: { label: t('developers.Completed'), type: 'success' },
    CREDITS_COMMITTED: { label: t('Transactions.CreditsCommitted'), type: 'default' },
    CREDITS_IN_DELIVERY: { label: t('Transactions.CreditsInDelivery'), type: 'processing' },
    IN_REVIEW: { label: t('Transactions.InReview'), type: 'processing' },
    VALIDATED: { label: t('Transactions.Validated'), type: 'success' }
  }[status]

  return <CustomTag text={saleStatus.label} type={saleStatus.type} />
}

export default SaleStatusColumn
